module.exports = __webpack_public_path__ + "assets/img/vivoo.dbe9298f.png";